import { render, staticRenderFns } from "./FormularioGastosPagos.vue?vue&type=template&id=cd08fc50&scoped=true"
import script from "./FormularioGastosPagos.vue?vue&type=script&lang=js"
export * from "./FormularioGastosPagos.vue?vue&type=script&lang=js"
import style0 from "./FormularioGastosPagos.vue?vue&type=style&index=0&id=cd08fc50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd08fc50",
  null
  
)

export default component.exports